import React, { useState, useEffect } from 'react';
import axios from 'axios';
function auth() { return { headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } }; }

export default function ScimConfig({ user }) {
  const [config, setConfig] = useState(null);
  const [users, setUsers] = useState([]);
  const [msg, setMsg] = useState({ text:'', type:'' });
  const [form, setForm] = useState({ provider:'azure_ad', name:'', bearerToken:'', syncUsers:true, syncGroups:true, active:false });
  const [saving, setSaving] = useState(false);
  const [tab, setTab] = useState('config');

  function flash(t,type='success') { setMsg({text:t,type}); setTimeout(()=>setMsg({text:'',type:''}),4000); }
  useEffect(()=>{
    axios.get('/api/scim/config',auth()).then(r=>setConfig(r.data)).catch(()=>{});
    axios.get('/api/scim/v2/Users',auth()).then(r=>setUsers(r.data.Resources||[])).catch(()=>{});
  },[]);

  async function save(e) {
    e.preventDefault(); setSaving(true);
    try {
      await axios.post('/api/sso/configs',{ provider:'scim_token', name:form.name||'SCIM', active:form.active, ...form },auth());
      flash('SCIM configuration saved');
      const r = await axios.get('/api/scim/config',auth()); setConfig(r.data);
    } catch(e) { flash(e.response?.data?.error||'Failed','error'); } finally { setSaving(false); }
  }

  const domain = window.location.origin;
  const PROVIDERS = [
    { id:'azure_ad', label:'Microsoft Entra ID', icon:'🟦', setupUrl:'https://portal.azure.com' },
    { id:'okta',     label:'Okta',               icon:'🔵', setupUrl:'https://developer.okta.com' },
    { id:'google',   label:'Google Workspace',   icon:'🔴', setupUrl:'https://admin.google.com' },
    { id:'onelogin', label:'OneLogin',            icon:'🟠', setupUrl:'https://www.onelogin.com' },
    { id:'custom',   label:'Custom IdP',          icon:'🏢', setupUrl:'' },
  ];

  return (
    <div style={{padding:24}}>
      {msg.text&&<div style={{padding:'10px 16px',borderRadius:8,marginBottom:16,background:msg.type==='error'?'#fee2e2':'#dcfce7',color:msg.type==='error'?'#dc2626':'#16a34a',fontWeight:600}}>{msg.type==='error'?'✘':'✔'} {msg.text}</div>}
      <div style={{marginBottom:24}}><h2 style={{margin:0,fontSize:20,fontWeight:700}}>SCIM 2.0 Provisioning</h2><p style={{margin:'4px 0 0',color:'#64748b',fontSize:14}}>Automatically sync users and groups from Okta, Azure AD, Google Workspace</p></div>

      <div style={{display:'flex',gap:2,marginBottom:16,borderBottom:'2px solid #f1f5f9'}}>
        {[['config','Configuration'],['endpoints','SCIM Endpoints'],['users',`Users (${users.length})`]].map(([id,label])=>(
          <button key={id} onClick={()=>setTab(id)} style={{padding:'8px 16px',border:'none',borderBottom:tab===id?'2px solid #1e40af':'2px solid transparent',background:'none',cursor:'pointer',fontWeight:600,fontSize:13,color:tab===id?'#1e40af':'#64748b',marginBottom:-2}}>{label}</button>
        ))}
      </div>

      {tab==='config'&&(
        <>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))',gap:10,marginBottom:24}}>
            {PROVIDERS.map(p=>(
              <button key={p.id} onClick={()=>setForm(f=>({...f,provider:p.id,name:p.label}))} style={{padding:'12px 14px',background:form.provider===p.id?'#dbeafe':'#f8fafc',border:`2px solid ${form.provider===p.id?'#1e40af':'#e2e8f0'}`,borderRadius:10,cursor:'pointer',textAlign:'left'}}>
                <div style={{fontSize:22,marginBottom:4}}>{p.icon}</div>
                <div style={{fontWeight:700,fontSize:12,color:form.provider===p.id?'#1d4ed8':'#374151'}}>{p.label}</div>
              </button>
            ))}
          </div>
          <form onSubmit={save} style={{maxWidth:500}}>
            <div style={{marginBottom:14}}><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Bearer Token (IdP sends this to authenticate)</label>
              <input value={form.bearerToken||''} onChange={e=>setForm({...form,bearerToken:e.target.value})} type="password" placeholder="Generate a strong random token" style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} />
              <div style={{fontSize:11,color:'#64748b',marginTop:3}}>Use this token in your IdP's SCIM provisioning settings as the API token/bearer token</div>
            </div>
            <div style={{display:'flex',gap:16,marginBottom:14}}>
              {[['syncUsers','Sync Users'],['syncGroups','Sync Groups'],['active','Enable SCIM']].map(([k,l])=>(
                <label key={k} style={{display:'flex',gap:6,alignItems:'center',cursor:'pointer'}}>
                  <input type="checkbox" checked={!!form[k]} onChange={e=>setForm({...form,[k]:e.target.checked})} /><span style={{fontSize:13,fontWeight:600}}>{l}</span>
                </label>
              ))}
            </div>
            <button type="submit" disabled={saving} style={{padding:'10px 24px',background:saving?'#94a3b8':'#1e40af',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:saving?'default':'pointer'}}>{saving?'Saving...':'Save SCIM Config'}</button>
          </form>
        </>
      )}

      {tab==='endpoints'&&(
        <div style={{maxWidth:600}}>
          <div style={{background:'#f0f9ff',border:'1px solid #bae6fd',borderRadius:10,padding:'14px 18px',marginBottom:16}}>
            <div style={{fontWeight:700,color:'#0369a1',marginBottom:8}}>Configure your IdP with these settings:</div>
            {[
              ['SCIM Base URL',      `${domain}/api/scim/v2`],
              ['Users URL',          `${domain}/api/scim/v2/Users`],
              ['Groups URL',         `${domain}/api/scim/v2/Groups`],
              ['Service Provider',   `${domain}/api/scim/v2/ServiceProviderConfig`],
              ['Auth Method',        'Bearer Token (set above)'],
              ['SCIM Version',       '2.0'],
            ].map(([l,v])=>(
              <div key={l} style={{display:'grid',gridTemplateColumns:'160px 1fr',gap:8,marginBottom:6,fontSize:13}}>
                <span style={{fontWeight:600,color:'#374151'}}>{l}:</span>
                <code style={{color:'#0c4a6e',wordBreak:'break-all'}}>{v}</code>
              </div>
            ))}
          </div>
          <div style={{background:'#fff',border:'1px solid #e2e8f0',borderRadius:10,padding:14,fontSize:13}}>
            <div style={{fontWeight:700,marginBottom:8}}>Supported Operations</div>
            {[['Users','Create, Read, Update (activate/deactivate), Delete'],['Groups','Create, Read, Delete'],['Filters','userName eq, id eq'],['Patch','Replace active, roles']].map(([op,desc])=>(
              <div key={op} style={{marginBottom:4}}><span style={{fontWeight:600}}>{op}:</span> <span style={{color:'#64748b'}}>{desc}</span></div>
            ))}
          </div>
        </div>
      )}

      {tab==='users'&&(
        users.length===0 ? <div style={{textAlign:'center',padding:60,color:'#94a3b8'}}><div style={{fontSize:40}}>👤</div><div style={{fontWeight:600,marginTop:12}}>No SCIM-provisioned users yet</div><div style={{fontSize:14,marginTop:8}}>Enable SCIM in your IdP and assign the PatchSphere application to users</div></div> : (
          <table style={{width:'100%',borderCollapse:'collapse',background:'#fff',border:'1px solid #e2e8f0',borderRadius:12,overflow:'hidden'}}>
            <thead><tr style={{background:'#f8fafc'}}>
              {['Username','Display Name','Active','Role'].map(h=><th key={h} style={{padding:'10px 14px',textAlign:'left',fontSize:12,fontWeight:700,color:'#64748b',borderBottom:'1px solid #f1f5f9'}}>{h}</th>)}
            </tr></thead>
            <tbody>
              {users.map(u=>(
                <tr key={u.id} style={{borderBottom:'1px solid #f8fafc'}}>
                  <td style={{padding:'9px 14px',fontSize:13}}>{u.userName}</td>
                  <td style={{padding:'9px 14px',fontSize:13,fontWeight:500}}>{u.displayName}</td>
                  <td style={{padding:'9px 14px'}}><span style={{background:u.active?'#dcfce7':'#fee2e2',color:u.active?'#16a34a':'#dc2626',borderRadius:4,padding:'2px 7px',fontSize:11,fontWeight:700}}>{u.active?'Active':'Inactive'}</span></td>
                  <td style={{padding:'9px 14px',fontSize:12,color:'#64748b'}}>{u.roles?.[0]?.value||'viewer'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )
      )}
    </div>
  );
}
